<template>
  <div class="pa-3">
    <loader v-if="$wait.is('izdanja')"></loader>
    <v-container v-else>
       <div class="d-flex flex-column">
      <div style="width: 100%"  :class="hasAdminRights && getDeviceType === 'touch' ? 'd-flex justify-space-between' : ''">
        <span class="headline font-weight-light d-flex"> Izdanja <span class="d-flex pl-1" v-html="izdanjaTotal"></span> </span>
         <v-btn
              v-show="hasAdminRights && getDeviceType === 'touch'"
              @click="openDialog"
              fab
              elevation="0"
              color="primary"
              x-small
            >
              <v-icon>mdi-plus</v-icon></v-btn
            >
      </div>
      <div
          class="d-flex justify-space-between"
          :class="$vuetify.breakpoint.mdAndUp ? '' : 'flex-column'"
        >
          <div
            :style="
              $vuetify.breakpoint.mdAndUp
                ? 'min-width: 400px; max-width: 800px'
                : 'width:100%'
            "
          >
            <v-text-field
              dense
              label="Traži"
              v-model="searchPublications"
              outlined
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </div>
            <v-btn
              v-show="hasAdminRights && getDeviceType != 'touch'"
              color="primary"
              dark
              class="mb-2"
              @click="openDialog"
              >Dodaj izdanje</v-btn
            >
           
          </div>
        </div>
      <v-data-table
        :headers="headers"
        :search="searchPublications"
        :loading="$wait.is('getIzdanja') || $wait.is('getIzdanjaAttachments')"
        :items="izdanja"
        item-key="name"
        :items-per-page="getIzdanja.per_page"
        hide-default-footer
        class="elevation-1 curs"
        no-data-text="Nema podataka"
        no-results-text="Nema podataka"
        loading-text="Učitavanje..."
      >

        <template  v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                
                @click="goToIzdanje(item)"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                color="primary"
              >
                mdi-information
              </v-icon>
            </template>
            <span>Detaljan pregled</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="hasAdminRights"
                @click="editIzdanje(item)"
                class="mr-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Uredi</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-if="hasAdminRights"
                @click="deleteItem(item)"
                class="mr-2"
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Izbriši</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0 ma-o pt-0 pb-0 mt-0 mb-0">
            <div v-for="n in item.base" :key="n.id">
              <v-row>
                <v-col cols="12">
                  <span
                    class="pa-0 pt-2 pl-2 ml-12"
                    style="
                      font-style: normal;
                      font-size: 16px;
                      font-weight: normal;
                    "
                    >{{ n.name }}</span
                  >
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
          </td>
        </template> </v-data-table
      ><v-row justify="center">
        <v-dialog
          :fullscreen="!$vuetify.breakpoint.mdAndUp"
          max-width="700"
          persistent
          v-model="openDetails"
        >
          <v-toolbar color="rgb(8, 71, 118)" v-if="getOdabranoIzdanje">
            <h4 style="color: white">{{ getOdabranoIzdanje.naziv }}</h4>
            <v-spacer></v-spacer>
            <v-icon @click="closeDetails" class="mr-2" color="white" right
              >mdi-close</v-icon
            ></v-toolbar
          >
          <detalji-izdanja></detalji-izdanja> </v-dialog
      ></v-row>

      <div class="text-center pt-2">
        <v-pagination
          v-model="page"
          @input="goTo"
          :length="getIzdanja.last_page"
          total-visible="20"
        ></v-pagination>
      </div>
      <v-dialog
        v-model="novoIzdanje"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
        max-width="600px"
      >
        <v-card>
          <v-card-title style="background-color: rgb(8, 71, 118)">
            <span v-if="inEdit" style="color: white">Uređivanje izdanja</span>
            <span v-else style="color: white">Novo izdanje</span>
            <v-spacer></v-spacer>
            <v-icon color="white" @click="close">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="mt-8">
            <v-form ref="form">
              <v-autocomplete
                v-model="selectedTip"
                :items="getTipoviIzdanja.data"
                dense
                outlined
                label="Odaberi tip izdanja*"
                item-text="naziv"
                :rules="[rules.tipRules]"
                return-object
              ></v-autocomplete>
              <v-text-field
                label="Naziv izdanja*"
                v-model="naziv"
                outlined
                dense
                required
                :rules="[rules.nameRules]"
              >
              </v-text-field>
              <v-autocomplete
                multiple
                chips
                v-model="selectDatabase"
                :items.sync="getAllBaze.data"
                outlined
                dense
                label="Odaberi bazu izdanja"
                item-text="naziv"
                return-object
              ></v-autocomplete>
              <v-autocomplete
                multiple
                chips
                v-model="selectPublisher"
                :items.sync="getAllIzdavaci.data"
                outlined
                dense
                label="Odaberi izdavača"
                item-text="naziv"
                return-object
              ></v-autocomplete>

              <v-row v-if="selectedTip">
                <v-col
                  :cols="getDeviceType === 'touch' ? 6 : 4"
                  v-if="selectedTip.issn === '1'"
                >
                  <v-text-field outlined dense v-model="issn" label="ISSN"></v-text-field>
                </v-col>
                <v-col
                  :cols="getDeviceType === 'touch' ? 6 : 4"
                  v-if="selectedTip.isbn === '1'"
                >
                  <v-text-field outlined dense v-model="isbn" label="ISBN"></v-text-field>
                </v-col>
                <v-col
                  :cols="getDeviceType === 'touch' ? 6 : 4"
                  v-if="selectedTip.broj === '1'"
                >
                  <v-text-field outlined dense v-model="broj" label="Broj"></v-text-field>
                </v-col>
                <v-col
                  :cols="getDeviceType === 'touch' ? 6 : 4"
                  v-if="selectedTip.mjesto_izdavanja === '1'"
                >
                  <v-text-field outlined dense
                    v-model="mjesto_izdavanja"
                    label="Mjesto izdavanja"
                  ></v-text-field>
                </v-col>
                <v-col
                  :cols="getDeviceType === 'touch' ? 6 : 4"
                  v-if="selectedTip.urednik === '1'"
                >
                  <v-text-field outlined dense
                    v-model="urednik"
                    label="Urednik"
                  ></v-text-field>
                </v-col>
                <v-col :cols="getDeviceType === 'touch' ? 6 : 4">
                  <v-switch
                    v-model="relevantnost"
                    label="Relevantnost"
                  ></v-switch>
                  <!-- <v-text-field v-model="relevantnost" label="Relevantnost"></v-text-field> -->
                </v-col>
                <v-col :cols="getDeviceType === 'touch' ? 6 : 4">
                  <v-switch
                    v-model="znanstvena_publikacija"
                    label="Znanstvena publikacija"
                  ></v-switch>
                  <!-- <v-text-field v-model="znanstvena_publikacija" label="Znanstvena publikacija"></v-text-field> -->
                </v-col>
              </v-row>
            </v-form>
            <hint
              v-if="!inEdit"
              :hints="getIzdanjaHints"
              :isSelectable="false"
            ></hint>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!isValid"
              @click="save"
              color="rgb(8, 71, 118)"
              style="color: white"
              class="mr-4 mb-2 mt-n5"
              >Spremi</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deleteDialog"
        persistent
        no-click-animation
        max-width="290"
      >
        <v-card :loading="$wait.is('deleteIzdanje')">
          <v-card-title class="headline">Izbriši izdanje</v-card-title>
          <v-card-text
            >Da li ste sigurni da želite izbrisati izdanje?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="deleteDialog = false"
              >Ne</v-btn
            >
            <v-btn color="red darken-1" text @click="Delete">Izbriši</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";
import _ from "lodash";
export default {
  metaInfo: {
    title: "Izdanja - Registar radova",
  },
  data: () => ({
    name: "Izdanja",
    rules: {
      nameRules: (v) => !!v || "Naziv izdanja je obavezan!",
      tipRules: (v) => !!v || "Tip izdanja je obavezan",
    },
    search: "",
    headers: [
      {
        text: "Naziv",
        align: "start",
        value: "naziv",
        sortable: false,
      },
      {
        text: "Tip izdanja",
        align: "start",
        value: "tip",
        sortable: false,
      },
      { text: "", value: "actions", sortable: false, align: "end" },
    ],
    inEdit: false,
    selectedForDelete: {},
    selectIzdanje: {},
    deleteDialog: false,
    novoIzdanje: false,
    selectedTip: null,
    // selectDatabase: null,
    issn: null,
    isbn: null,
    broj: null,
    // selectPublisher: null,
    mjesto_izdavanja: null,
    urednik: null,
    relevantnost: false,
    znanstvena_publikacija: false,
    naziv: "",
    page: 1,
    selectedIzdanje: null,
    openDetails: false,
  }),
  // setIzdanjaBaze
  // setIzdanjaIzdavaci
  computed: {
    ...mapGetters([
      "getIzdanja",
      "getTipoviIzdanja",
      "getDeviceType",
      "hasAdminRights",
      "getEditionDatabases",
      "getPublishers",
      "getIzdanjeBaze",
      "getIzdanjeIzdavaci",
      "getOdabranoIzdanje",
      "getIzdanjaHints",
      "getAllIzdavaci",
      "getAllBaze",
    ]),
    isValid() {
      return this.naziv != "" && this.selectedTip;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    selectDatabase: {
      set(value) {
        if (value) {
          this.$store.dispatch("setIzdanjaBaze", value);
        }
      },
      get() {
        return this.getIzdanjeBaze;
      },
    },
    selectPublisher: {
      set(value) {
        if (value) {
          this.$store.dispatch("setIzdanjaIzdavaci", value);
        }
      },
      get() {
        return this.getIzdanjeIzdavaci;
      },
    },
    searchPublications: {
      set(value) {
        if (value != this.search) {
          this.search = value;
          waitFor("getIzdanja", async function () {
            await this.$store.dispatch("getIzdanja", {
              page: 1,
              search: value,
            });
          }).apply(this);
        }
      },
      get() {
        return this.search;
      },
    },
    izdanja() {
      let izdanja = [];
      if (this.getIzdanja.data && this.getTipoviIzdanja.data) {
        this.getIzdanja.data.forEach((izd) => {
          let tip = this.getTipoviIzdanja.data.find(
            (tip) => tip.id == izd.tip_izdanja_id
          ).naziv;
          Object.assign(izd, { tip: tip });
          izdanja.push(izd);
        });
      }
      return izdanja;
    },
    izdanjaTotal(){
       return parseInt(this.getIzdanja.total)? '(<p class="" style="color: var(--v-primary-base)" id="numberOf">'+parseInt(this.getIzdanja.total)+'</p>)': ''
    }
  },

  watch: {
    naziv(newVal) {
      let self = this;
      this.getHint(self, newVal);
    },
  },

  created() {},
  beforeMount() {
    waitFor("izdanja", async function () {
      await this.$store.dispatch("getIzdanja", {
        page: 1,
        search: this.search,
      });
    }).apply(this);
  },

  methods: {
    getHint: _.debounce((self, value) => {
      waitFor("getIzdanjaHint", async function () {
        await self.$store.dispatch("getIzdanjaHint", {
          page: 1,
          search: value,
        });
      }).apply(self);
    }, 500),
    goToIzdanje(izdanje) {
      this.selectedIzdanje = izdanje;
      waitFor("getIzdanjeDetails", async function () {
        await this.$store.dispatch("fetchIzdanje", izdanje.id);
      }).apply(this);
      this.openDetails = true;
    },
    async closeDetails() {
      this.openDetails = false;
    },
    async deleteItem(item) {
      this.selectedForDelete = item;
      await waitFor("getIzdanjaAttachments", async function () {
        await this.$store.dispatch("getIzdanjaBaze", item.id);
        await this.$store.dispatch("getIzdanjaIzdavaci", item.id);
      }).apply(this);
      this.deleteDialog = true;
    },
    async Delete() {
      waitFor("deleteIzdanje", async function () {
        let bazeIzdanja = [];
        this.getIzdanjeBaze.forEach((baza) => {
          if (!bazeIzdanja.includes(baza.id)) {
            bazeIzdanja.push(baza.id);
          }
        });
        let izdavaci = [];
        this.getIzdanjeIzdavaci.forEach((izdavac) => {
          if (!izdavaci.includes(izdavac.id)) {
            izdavaci.push(izdavac.id);
          }
        });
        await this.$store.dispatch("detachIzdanjaBaze", {
          id: this.selectedForDelete.id,
          ids: bazeIzdanja,
        });
        await this.$store.dispatch("detachIzdanjaIzdavaci", {
          id: this.selectedForDelete.id,
          ids: izdavaci,
        });
        await this.$store
          .dispatch("deleteIzdanje", this.selectedForDelete.id)
          .then(() => {
            this.selectedForDelete = {};
            this.$store.dispatch("setIzdanjaBaze", []);
            this.$store.dispatch("setIzdanjaIzdavaci", []);
            this.deleteDialog = false;

            this.$store.dispatch("getIzdanja", {
              page: 1,
              search: this.search,
            });
          });
      }).apply(this);
    },
    async editIzdanje(item) {
      await waitFor("getIzdanjaAttachments", async function () {
        await this.$store.dispatch("getIzdanjaBaze", item.id);
        await this.$store.dispatch("getIzdanjaIzdavaci", item.id);
      }).apply(this);
      this.selectIzdanje = item;
      this.naziv = item.naziv;
      (this.selectedTip = this.getTipoviIzdanja.data.find(
        (tip) => tip.id == item.tip_izdanja_id
      )),
        (this.issn = item.issn);
      this.isbn = item.isbn;
      this.broj = item.broj;
      this.mjesto_izdavanja = item.mjesto_izdavanja;
      this.urednik = item.urednik;
      this.relevantnost = item.relevantnost === "1" ? true : false;
      this.znanstvena_publikacija =
        item.znanstvena_publikacija === "1" ? true : false;
      this.inEdit = true;
      this.novoIzdanje = true;
    },
    openDialog() {
      waitFor("new", async function () {
        await this.$store.dispatch("getAllIzdavaci");
        await this.$store.dispatch("getAllBaze");
      }).apply(this);
      this.inEdit = false;
      this.novoIzdanje = true;
    },
    goTo(item) {
      this.page = item;
      waitFor("getIzdanja", async function () {
        await this.$store.dispatch("getIzdanja", {
          page: item,
          search: this.search,
        });
      }).apply(this);
    },

    close() {
      this.naziv = null;
      this.selectedTip = {};
      this.issn = null;
      this.isbn = null;
      this.broj = null;
      this.mjesto_izdavanja = null;
      this.urednik = null;
      this.relevantnost = false;
      this.znanstvena_publikacija = false;
      this.novoIzdanje = false;
      this.inEdit = false;
      this.$store.dispatch("setIzdanjaBaze", []);
      this.$store.dispatch("setIzdanjaIzdavaci", []);
      this.$store.commit("SET_IZDANJA_HINTS", null);
      this.$refs.form.reset();
    },

    async save() {
      let bazeIzdanja = [];
      this.getIzdanjeBaze.forEach((baza) => {
        if (!bazeIzdanja.includes(baza.id)) {
          bazeIzdanja.push(baza.id);
        }
      });
      let izdavaci = [];
      this.getIzdanjeIzdavaci.forEach((izdavac) => {
        if (!izdavaci.includes(izdavac.id)) {
          izdavaci.push(izdavac.id);
        }
      });
      let newIzdanje = {
        naziv: this.naziv,
        selectedTip: this.selectedTip ? this.selectedTip : null,
        issn: this.issn ? this.issn : "",
        isbn: this.isbn ? this.isbn : "",
        broj: this.broj ? this.broj : "",
        mjesto_izdavanja: this.mjesto_izdavanja ? this.mjesto_izdavanja : "",
        urednik: this.urednik ? this.urednik : "",
        relevantnost: this.relevantnost,
        znanstvena_publikacija: this.znanstvena_publikacija,
        tip_izdanja_id: this.selectedTip ? this.selectedTip.id : null,
        relations: {
          bazeIzdanja: {
            method: "sync",
            data: bazeIzdanja,
          },
          izdavaci: {
            method: "sync",
            data: izdavaci,
          },
        },
      };
      if (this.inEdit) {
        Object.assign(newIzdanje, { id: this.selectIzdanje.id });
        this.$store.dispatch("editIzdanje", newIzdanje).then(() => {
          waitFor("izdanja", async function () {
            await this.$store.dispatch("getIzdanja", {
              page: 1,
              search: this.search,
            });
          }).apply(this);
          this.close();
        });
      } else {
        this.$store.dispatch("createNewIzdanje", newIzdanje).then(() => {
          this.close();
        });
      }
      this.$refs.form.reset();
    },
  },
};
</script>

<style lang="scss">
.curs > .v-data-table__wrapper > table tbody td {
  cursor: context-menu !important;
}
</style>